import DIApi from './_diApi';

class StatisticAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'Statistics';
}

export default new StatisticAPI();
